import * as React from 'react';
import { Fragment } from 'react';
import moment from 'moment';
import Day from './Day';
import { DATE_FORMAT } from './constants';
function Week(props) {
    var date = props.date, selected = props.selected, minDate = props.minDate, maxDate = props.maxDate, onDayClick = props.onDayClick, month = props.month;
    var momentCurrentDate = moment(date, DATE_FORMAT);
    var startOfMonth = momentCurrentDate
        .clone()
        .startOf('month')
        .startOf('day');
    var daysToPadLeft = startOfMonth.day() - 1;
    if (daysToPadLeft < 0)
        daysToPadLeft = 6;
    var cells = [];
    if (momentCurrentDate.isSame(startOfMonth) && daysToPadLeft) {
        cells = cells.concat(Array.from(Array(daysToPadLeft), function (_, x) { return (React.createElement("td", { className: "Calendar__day Calendar__day_blank", key: "start" + x })); }));
    }
    for (var i = cells.length; i < 7; i += 1) {
        var dayItem = (React.createElement(Day, { key: momentCurrentDate.valueOf(), date: momentCurrentDate.format(DATE_FORMAT), minDate: minDate, maxDate: maxDate, selected: selected, onDayClick: onDayClick }));
        if (month === momentCurrentDate.clone().format('M')) {
            cells.push(dayItem);
        }
        momentCurrentDate.add(1, 'd');
    }
    return React.createElement(Fragment, null, cells);
}
export default Week;
//# sourceMappingURL=Week.js.map